import { render, staticRenderFns } from "./TopicAssistantHome.vue?vue&type=template&id=d1517c8c&scoped=true"
import script from "./TopicAssistantHome.vue?vue&type=script&lang=js"
export * from "./TopicAssistantHome.vue?vue&type=script&lang=js"
import style0 from "./TopicAssistantHome.vue?vue&type=style&index=0&id=d1517c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1517c8c",
  null
  
)

export default component.exports